import { cn } from '@/theme1/lib/cn';

export function Container({ children, className = '' }) {
    return (
        <div
            className={cn(
                'mx-auto w-full px-10 2xl:px-0',
                'max-w-screen-2xl',
                className,
            )}
        >
            {children}
        </div>
    );
}
